<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="equipment">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i>设备管理
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="toAddNew">新增</button>
        </div>
        <div class="searchForm1">
          <searchForm
            :items="items"
            :formPlus="form_jsgl"
            ref="searchForm_jsgl"
          >
            <template slot="last">
              <el-form-item label="名称">
                <el-input
                  placeholder="请输入名称"
                  v-model="seefrom.name"
                ></el-input>
              </el-form-item>
              <el-form-item label="编码">
                <el-input
                  placeholder="请输入编码"
                  v-model="seefrom.mark"
                ></el-input>
              </el-form-item>
              <el-form-item label="平台">
                <!-- <el-input placeholder="请输入平台" v-model="seefrom.platformId"></el-input> -->
                <el-select
                  placeholder="请选择平台"
                  v-model="seefrom.platformId"
                >
                  <el-option
                    v-for="item in selectPlatform"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/camera/query"
            :parent="self"
            :config="config"
            :other="other"
            ref="Equipment"
          >
            <template slot="last">
              <el-table-column
                prop="useType"
                label="摄像头类型"
                :formatter="typeMatter"
                width="150"
              >
              </el-table-column>
              <el-table-column label="操作" width="250">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="toEdit(scope.$index, scope.row, true)"
                    >编辑</el-link
                  >
                  <!-- <el-link icon="iconfont iconadd" type="text" size="small">添加</el-link> -->
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    @click="deleteEquipment(scope.$index, scope.row)"
                    >删除</el-link
                  >
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <el-dialog
          class="editDialog"
          :title="title"
          :visible.sync="editDialogForm"
        >
          <el-form :model="addEquipment" ref="addEquipment">
            <el-form-item label="名称" prop="name">
              <el-input
                placeholder="请输入名称"
                v-model="addEquipment.name"
              ></el-input>
            </el-form-item>
            <el-form-item label="编码" prop="mark">
              <el-input
                placeholder="请输入编码"
                v-model="addEquipment.mark"
              ></el-input>
            </el-form-item>
            <el-form-item label="厂家" prop="factory">
              <el-input
                placeholder="请输入厂家"
                v-model="addEquipment.factory"
              ></el-input>
            </el-form-item>
            <el-form-item label="型号" prop="model">
              <el-input
                placeholder="请输型号"
                v-model="addEquipment.model"
              ></el-input>
            </el-form-item>
            <el-form-item label="通道号" prop="channel_id">
              <el-input
                placeholder="请输入通道号"
                v-model="addEquipment.channel_id"
              ></el-input>
            </el-form-item>
            <el-form-item label="平台" prop="platformId">
              <!-- <el-input placeholder="请输入平台" v-model="addEquipment.platformId"></el-input> -->
              <el-select
                placeholder="请选择平台"
                v-model="addEquipment.platformId"
              >
                <el-option
                  v-for="item in selectPlatform"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="摄像头告警类型" prop="useType">
              <el-select
                placeholder="请选择摄像头类型"
                v-model="addEquipment.useType"
              >
                <el-option
                  v-for="item in cameraType"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="监控区域" prop="areaId">
              <!-- <el-input placeholder="请选择监控区域" v-model="addEquipment.areaId"></el-input> -->
              <el-input
                placeholder="请选择区域"
                v-model="addEquipment.areaName"
                @focus="changeAreaMode(1)"
              ></el-input>
            </el-form-item>
            <el-form-item label="视频url" prop="url">
              <el-input
                placeholder="请输入视频url"
                v-model="addEquipment.url"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="editDialogForm = false"
              >取消</el-button
            >
            <el-button class="confirmButton" @click="Confirm">确定</el-button>
          </div>
        </el-dialog>
        <!-- 区域树 -->
        <mountPoint
          :hasChildNodes="areaTreeMode"
          :dialogVisible="areaTreeVisible"
          @regionTreeClose="areaTreeVisible = false"
          @regionTreeData="selRegionData"
        ></mountPoint>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //区域树是否显示
      areaTreeVisible: false,
      inputReadOnly: false,
      //区域树模式选择
      areaTreeMode: true,
      title: "",
      tabName: "equipment",
      form_jsgl: {},
      showTable: true,
      items: [],
      other: {},
      editDialogForm: false,
      seefrom: {
        name: "",
        mark: "",
        platform: "",
      },
      addEquipment: {
        name: "",
        mark: "",
        factory: "",
        model: "",
        channel_id: "",
        platformId: "",
        platformName: "",
        areaId: "",
        areaName: "",
        url: "",
        useType: "",
      },
      status: "",
      selectPlatform: [],
      edit_id: "",
      cameraType: [
        { id: "eBike", name: "电瓶车监控" },
        { id: "fireEscape", name: "消防通道监控" },
      ],
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "name",
          label: "名称",
        },
        {
          prop: "mark",
          label: "编码",
        },
        {
          prop: "factory",
          label: "厂家",
        },
        {
          prop: "model",
          label: "型号",
        },
        {
          prop: "channel_id",
          label: "通道号",
        },
        {
          prop: "platformName",
          label: "平台",
        },
        {
          prop: "areaName",
          label: "监控区域",
        },
      ];
    },
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    mountPoint: () => import("public/mountPoint"),
  },
  methods: {
    //摄像头类型
    typeMatter(row, column) {
      if(row.useType === "eBike") {
        return "电瓶车监控"
      } else {
        return "消防通道监控"
      }
    },
    //搜索
    subSeefrom() {
      this.other = this.seefrom;
      this.$nextTick(this.$refs.Equipment.getData);
    },
    //重置
    reset() {
      this.seefrom.name = "";
      this.seefrom.mark = "";
      this.seefrom.platformId = "";
    },
    //新增
    toAddNew() {
      this.status = 1;
      this.editDialogForm = true;
      this.addEquipment = {
        name: "",
        mark: "",
        factory: "",
        model: "",
        channel_id: "",
        platformId: "",
        platformName: "",
        areaId: "",
        areaName: "",
        url: "",
      };
      this.title = "新增设备";
      if (this.$refs["addEquipment"])
        this.$refs["addEquipment"].clearValidate();
    },
    //修改
    toEdit(index, row) {
      this.title = "修改设备";
      this.status = 2;
      this.editDialogForm = true;
      this.addEquipment.name = row.name;
      this.addEquipment.mark = row.mark;
      this.addEquipment.factory = row.factory;
      this.addEquipment.model = row.model;
      this.addEquipment.channel_id = row.channel_id;
      this.addEquipment.platformName = row.platformName;
      this.addEquipment.platformId = row.platformId;
      this.addEquipment.areaName = row.areaName;
      this.addEquipment.areaId = row.areaId;
      this.addEquipment.url = row.url;
      this.addEquipment.useType = row.useType;
      this.edit_id = row.id;
      if (this.$refs["addEquipment"])
        this.$refs["addEquipment"].clearValidate();
    },
    //确认
    Confirm() {
      if (this.status === 1) {
        this.$axiospost("operation/camera/add", {
          name: this.addEquipment.name,
          mark: this.addEquipment.mark,
          useType: this.addEquipment.useType,
          factory: this.addEquipment.factory,
          model: this.addEquipment.model,
          channel_id: this.addEquipment.channel_id,
          platformId: this.addEquipment.platformId,
          areaId: this.addEquipment.areaId,
          url: this.addEquipment.url,
        }).then((res) => {
          this.subSeefrom();
          this.editDialogForm = false;
        });
      } else if (this.status === 2) {
        this.$axiospost("operation/camera/modify", {
          id: this.edit_id,
          name: this.addEquipment.name,
          mark: this.addEquipment.mark,
          useType: this.addEquipment.useType,
          factory: this.addEquipment.factory,
          model: this.addEquipment.model,
          channel_id: this.addEquipment.channel_id,
          platformId: this.addEquipment.platformId,
          areaId: this.addEquipment.areaId,
          url: this.addEquipment.url,
        }).then((res) => {
          this.subSeefrom();
          this.editDialogForm = false;
        });
      }
    },
    //删除
    deleteEquipment(index, row) {
      var formData = new FormData();
      formData.append("cameraId", row.id);
      this.$confirm("是否删除该网关？", "删除操作", {
        confirmButton: "确定",
        cancelButton: "取消",
        type: "warning",
      }).then(() => {
        this.$axiospost("operation/camera/delete", formData).then((res) => {
          this.$message.success("删除成功！");
          this.subSeefrom();
        });
      });
    },
    //选择区域模式变化
    changeAreaMode(mode) {
      this.areaTreeVisible = true;
      if (mode === 1) this.areaTreeMode = true;
      if (mode === 2) this.areaTreeMode = false;
      this.areaMode = mode;
    },
    //区域树选择完回调
    selRegionData(a, ...b) {
      let mode = this.areaMode;
      if (mode === 1) {
        this.addEquipment.areaId = a.id;
        this.addEquipment.areaName = a.name;
      } else if (mode === 2) {
        if (!a.type || a.type !== 1) {
          this.$set(this.addEquipment, "region", null);
          this.addEquipment.regionName = "";
          return;
        }
        this.$set(this.addEquipment, "region", a.id);
        this.addEquipment.regionName = a.name;
      }
    },
  },
  created() {
    this.$axiosget("operation/video/query", {
      params: {
        pageNum: 1,
        pageSize: 1000,
      },
    }).then((res) => {
      //console.log(res.data.data, "res");
      this.selectPlatform = res.data.data.list;
    });
  },
};
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/vedio/equipment.vue